import { ServerApiMapper} from '~commonInfra/utils/ServerModelHelper';
import { IListFetcher } from '~src/httpClient/fetchers/IListFetcher';
import { WebClientListResourceFetcher } from '~src/httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { ResourceQuery } from '~src/httpClient/resources/ResourceQuery';
import { IRecentContentInfo } from '~src/recents/models/IRecentContentInfo';
import { GetDetailedRecentsRequest } from '~src/recents/requests/GetDetailedRecentsRequest';
import { ExplorableItemType, ExplorableItemTypeValue } from '~src/spacesPlatform/models/ContentType';
import { ILeafFilterClause } from '~src/spacesPlatform/models/IFilterClause';
import { IUserInfo } from '~src/userManagement/users/models/IUserInfo';

export const RecentsSupportedContentTypes: ReadonlyArray<ExplorableItemType> =
  [ExplorableItemTypeValue.view, ExplorableItemTypeValue.flow, ExplorableItemTypeValue.metric];

class RecentsResource {

  private getRecentViews: IListFetcher<IRecentContentInfo> = new WebClientListResourceFetcher(
    GetDetailedRecentsRequest, ServerApiMapper.recentItems);

  private getRecentUsersFetcher: IListFetcher<IUserInfo> = new WebClientListResourceFetcher(
    GetDetailedRecentsRequest, ServerApiMapper.recentUniqueUsers);

  public all(contentTypes: ReadonlyArray<ExplorableItemType>, additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IRecentContentInfo> {
    const extraParams = this.getExtraParams(contentTypes);

    return new ResourceQuery(this.getRecentViews)
      .withExtraParams(extraParams)
      .withFilters(additionalFilterClauses);
  }

  public users(contentTypes: ReadonlyArray<ExplorableItemType>, additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IUserInfo> {
    const extraParams = this.getExtraParams(contentTypes);

    return new ResourceQuery(this.getRecentUsersFetcher)
      .withExtraParams(extraParams)
      .withFilters(additionalFilterClauses);
  }

  private getExtraParams(contentTypes: ReadonlyArray<ExplorableItemType>) {
    const objectTypes = contentTypes.filter(type => RecentsSupportedContentTypes.includes(type));

    // viewStatFields doesn't seem to be used anywhere for recents, so remove from the payload params
    return {objectTypes};
  }
}

export const Recents = new RecentsResource();
